<script setup lang="ts">
import { computed } from 'vue'

import { Datepicker } from '@collector/shared-ui'
import { formatDateInTimezone } from '@collector/shared-utils'
import { sportsApiClient } from '@desktop/globalState/sportsApiClient'
import { useEvent } from '@desktop/views/Relation/composables'

import { injectSuccessBadge } from '../../successBadge'

// inject
const { showSuccessBadge } = injectSuccessBadge()

// composables
const { event } = useEvent()

// methods
function shouldUpdateValue(startDate: string): boolean {
  const formattedValueWithoutSeconds = formatDate(new Date(startDate))
  return formattedValueWithoutSeconds !== event.value.start_date
}

async function updateValue(value: string): Promise<void> {
  if (!shouldUpdateValue(value)) {
    return
  }

  await sportsApiClient.Events.patch(event.value.id, {
    event: { start_date: value },
  })

  showSuccessBadge()
}

function formatDate(date: Date): string {
  return formatDateInTimezone(date, 'yyyy-MM-dd HH:mm')
}

function formatStartDate(hours: number, minutes: number): string {
  const date = new Date(event.value.start_date)

  date.setHours(hours, minutes)

  return formatDate(date).replace(' ', 'T')
}

// computed
const min = computed(() => formatStartDate(0, 0))
const max = computed(() => formatStartDate(23, 59))
</script>

<template>
  <Datepicker
    :modelValue="event.start_date"
    mode="datetime"
    :min
    :max
    @blur="({ formattedValue }) => updateValue(formattedValue)"
  >
    Start date
  </Datepicker>
</template>
